module.exports = __webpack_public_path__ + "img/twitter.a4c80d93.svg";